import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addButton", "empty", "item", "list", "template"]
  static values = { max: Number }

  connect() {
    this.reindex()
  }

  add(event) {
    event.preventDefault()
    if (this.hasMaxValue && this.itemTargets.length >= this.maxValue) return

    const fragment = this.templateTarget.content.cloneNode(true)
    this.listTarget.appendChild(fragment)
    this.reindex()
  }

  remove(event) {
    event.preventDefault()
    const item = this.itemForEvent(event)
    if (!item) return

    item.remove()
    this.reindex()
  }

  moveUp(event) {
    event.preventDefault()
    const item = this.itemForEvent(event)
    if (!item || !item.previousElementSibling) return

    item.previousElementSibling.before(item)
    this.reindex()
  }

  moveDown(event) {
    event.preventDefault()
    const item = this.itemForEvent(event)
    if (!item || !item.nextElementSibling) return

    item.nextElementSibling.after(item)
    this.reindex()
  }

  reindex() {
    this.itemTargets.forEach((item, index) => {
      item.querySelectorAll("[data-repeater-name-template]").forEach((field) => {
        field.name = field.dataset.repeaterNameTemplate.replaceAll("__INDEX__", index)
      })

      item.querySelectorAll("[data-repeater-id-template]").forEach((field) => {
        field.id = field.dataset.repeaterIdTemplate.replaceAll("__INDEX__", index)
      })

      item.querySelectorAll("[data-repeater-for-template]").forEach((field) => {
        field.htmlFor = field.dataset.repeaterForTemplate.replaceAll("__INDEX__", index)
      })

      item.querySelectorAll("[data-repeater-label-template]").forEach((field) => {
        field.textContent = field.dataset.repeaterLabelTemplate.replaceAll("__NUMBER__", index + 1)
      })

      const moveUpButton = item.querySelector("[data-repeater-move-up]")
      if (moveUpButton) moveUpButton.disabled = index === 0

      const moveDownButton = item.querySelector("[data-repeater-move-down]")
      if (moveDownButton) moveDownButton.disabled = index === this.itemTargets.length - 1
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("d-none", this.itemTargets.length > 0)
    }

    if (this.hasAddButtonTarget && this.hasMaxValue) {
      this.addButtonTarget.disabled = this.itemTargets.length >= this.maxValue
    }
  }

  itemForEvent(event) {
    return event.target.closest("[data-repeater-target='item']")
  }
}
